"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndpointConfig = exports.init = void 0;
const axios_1 = require("axios");
require('dotenv').config();
function init(token, baseURL) {
    axios_1.default.defaults.baseURL = baseURL;
    axios_1.default.defaults.headers.common['Authorization'] = `bearer ${token}`;
}
exports.init = init;
function getEndpointConfig() {
    return {
        url: axios_1.default.defaults.baseURL,
        headers: axios_1.default.defaults.headers
    };
}
exports.getEndpointConfig = getEndpointConfig;
//# sourceMappingURL=Setup.js.map